if (!customElements.get('announcement-slider')) {
 customElements.define('announcement-slider', class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort();
   this.abort = new AbortController();
   this.group = this.querySelector('[data-announcement-group]');
   if (!this.group) return;
   const update = () => {
    cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(() => {
     this.style.setProperty('--announcement-min-width', this.clientWidth + 'px');
     this.style.setProperty('--announcement-duration', this.group.getBoundingClientRect().width / 32 + 's');
    });
   };
   this.observer?.disconnect();
   this.observer = new ResizeObserver(update);
   this.observer.observe(this);
   this.observer.observe(this.group);
   document.addEventListener('visibilitychange', () => this.toggleAttribute('data-page-hidden', document.hidden), { signal:this.abort.signal });
   this.toggleAttribute('data-page-hidden', document.hidden);
   document.fonts.ready.then(() => { if (this.isConnected) update(); });
   update();
  }
  disconnectedCallback() {
   this.abort?.abort();
   this.observer?.disconnect();
   cancelAnimationFrame(this.frame);
  }
 });
}
